const stateRoot = (state) => state.login;

export const getEmail = (state) => stateRoot(state).email;

export const getPassword = (state) => stateRoot(state).password;

export const getTwoFaChallengeId = (state) => stateRoot(state).twoFaChallengeId;

export const getTwoFaEmail = (state) => stateRoot(state).twoFaEmail;

export const getTwoFaError = (state) => stateRoot(state).twoFaError;
